
import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

function About() {
  const teamMembers = [
    {
      name: 'Jenna Muntz',
      role: 'Founder & CEO',
      image: 'https://randomuser.me/api/portraits/women/23.jpg',
      bio: 'Agricultural Educator, Farmer, and Entepreneur. Experience with cattle operations across the Midwest.'
    },
    {
      name: 'Thad Meyer',
      role: 'Cofounder & CTO',
      image: 'https://randomuser.me/api/portraits/men/45.jpg',
      bio: 'Technical expert with a background in ag technology.'
    },
    {
      name: 'Sarah Williams',
      role: 'Community Manager',
      image: 'https://randomuser.me/api/portraits/women/67.jpg',
      bio: 'Passionate about connecting rural communities with the resources they need to thrive.'
    }
  ];
 return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>About Herding Helpers</h1>
          <p className="subtitle">Connecting farmers with skilled herding assistance since 2020</p>
        </div>
      </section>

      <section className="our-story">
        <div className="container">
          <div className="story-content">
            <div className="story-text">
              <h2>Our Story</h2>
              <p>
                Herding Helpers was born from the experiences of Jenna Muntz, a young woman raised in a family where farming and emergency response went hand in hand. Growing up on her family's farm in Nebraskana, Jenna watched her father and uncles—who served as both ranchers and volunteer firefighters—drop everything to help neighbors during crises. Whether it was a wildfire threatening livestock, a blizzard stranding cattle, or equipment failures during critical seasons, she witnessed how rural communities naturally came together in times of need.
              </p>
              <p>
                The challenge Jenna observed wasn't a lack of willingness to help—it was communication. Too often, farmers in distress couldn't quickly reach the right people with the right equipment and expertise. After winning a technology innovation competition at Concordia University with her proposal for a digital platform connecting agricultural helpers, Jenna partnered with her longtime friend and mentor to turn this vision into reality.
              </p>
              <p>
                What started as a solution for her home community in Nebraska has grown into a nationwide network, helping thousands of farms and ranches coordinate emergency assistance when they need it most. Herding Helpers embodies the spirit of rural cooperation, enhanced by modern technology.
              </p>
            </div>
            <div className="story-image">
		<img src="https://images.unsplash.com/photo-1500595046743-cd271d694d30?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Herding Helpers origin story" />
            </div>
          </div>
        </div>
      </section>
      <section className="our-mission">
        <div className="container">
          <h2>Our Mission</h2>
          <div className="mission-content">
            <div className="mission-item">
              <i className="fas fa-handshake"></i>
              <h3>Connect</h3>
              <p>Create meaningful connections between farmers and skilled herding professionals.</p>
            </div>
            <div className="mission-item">
              <i className="fas fa-shield-alt"></i>
              <h3>Protect</h3>
              <p>Ensure the safety and well-being of both livestock and the people who care for them.</ p>
            </div>
            <div className="mission-item">
              <i className="fas fa-seedling"></i>
              <h3>Sustain</h3>
              <p>Support sustainable agricultural practices and the future of family farming.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="team-section">
        <div className="container">
          <h2>Meet Our Team</h2>
          <div className="team-grid">
            {teamMembers.map((member, index) => (
              <div className="team-member" key={index}>
                <div className="member-image">
                  <img src={member.image} alt={member.name} />
                </div>
                <h3>{member.name}</h3>
                <p className="member-role">{member.role}</p>
                <p className="member-bio">{member.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="values-section">
        <div className="container">
          <h2>Our Values</h2>
          <div className="values-content">
            <div className="values-text">
              <ul>
                <li><strong>Integrity:</strong> We believe in honest, transparent relationships between all parties.</li>
                
                <li><strong>Community:</strong> We're committed to strengthening rural communities and agricultural traditions.</li>
                <li><strong>Innovation:</strong> We embrace new technologies that make farming safer, more efficient, and sustainable.</li>
                <li><strong>Reliability:</strong> We understand that farmers depend on consistent,      dependable help--from us, and from each other..</li>
              </ul>
            </div>
              <div className="values-image">
          <img src="https://images.unsplash.com/photo-1544965503-7ad532c2c4a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Herding Helpers values" />
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2>Join the Herding Helpers Community</h2>
          <p>Whether you're looking for help or offering your skills, we'd love to have you.</p>
          <div className="cta-buttons">
            <Link to="/signup" className="button primary-button">Sign Up Today</Link>
            <Link to="/contact" className="button secondary-button">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;
